import { useSelector } from "react-redux";

export const useCurrentUser = () => {
  const user = useSelector(state => state.auth.CurrentUser);
  return { user };
};
